import * as React from "react";
import {
  createContext,
  useContext,
  ReactNode,
  useState,
  useEffect,
} from "react";
import { useSearchParams, useParams } from "react-router-dom";

interface OwnerContextType {
  isEditView: boolean;
  setIsEditView: (value: boolean) => void;
  isOwnerView: boolean;
  setIsOwnerView: (value: boolean) => void;
  trigger: number;
  fireTrigger: () => void;
}

const OwnerContext = createContext<OwnerContextType | undefined>(undefined);

export function OwnerProvider({ children }: { children: ReactNode }) {
  const [searchParams, setSearchParams] = useSearchParams();
  const { address } = useParams();
  const [isEditView, setIsEditViewState] = useState(false);
  const [isOwnerView, setIsOwnerViewState] = useState(true);

  // произвольный триггер
  const [trigger, setTrigger] = useState(0);
  const fireTrigger = () => setTrigger(prev => prev + 1);

  const setIsEditView = (value: boolean) => {
    setIsEditViewState(value);
  };

  const setIsOwnerView = (value: boolean) => {
    setIsOwnerViewState(value);

    if (address) {
      const newParams = new URLSearchParams(searchParams);
      newParams.set("view", value ? "owner" : "user");
      setSearchParams(newParams, { replace: true });
    }
  };

  useEffect(() => {
    if (address) {
      const viewFromParams = searchParams.get("view");
      if (viewFromParams) {
        setIsOwnerViewState(viewFromParams === "owner");
      }
    }
  }, [address, searchParams]);

  return (
    <OwnerContext.Provider
      value={{
        isEditView,
        setIsEditView,
        isOwnerView,
        setIsOwnerView,
        trigger,
        fireTrigger,
      }}
    >
      {children}
    </OwnerContext.Provider>
  );
}

export function useOwner() {
  const context = useContext(OwnerContext);
  if (context === undefined) {
    throw new Error("useOwner must be used within an OwnerProvider");
  }
  return context;
}
